"use client";

import { Rating } from "@atlas/core";

interface ICatalogRatingProps {
  averageRating: number | undefined;
}

export function CatalogRating({ averageRating }: ICatalogRatingProps) {
  return (
    <Rating
      rating={averageRating ?? 0}
      maxRating={5}
      precision={0.1}
      showValue={true}
      size="md"
      readonly={true}
    />
  );
}
